module.exports = __webpack_public_path__ + "img/trophy-awards-dark.8d3e3feb.svg";